import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { AltenarConverter } from './AltenarConverter'

class AltenarApi extends BaseHttpService {
  private converter

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/integrations/altenar/v2`
    this.converter = new AltenarConverter()
  }

  getToken = () =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/login`,
      converterSuccess: this.converter.convertToken,
    })
}

export default AltenarApi
